import classNames from "classnames";
import PropTypes from "prop-types";

import classes from "./flex.module.scss";

function Flex({
  direction,
  justify,
  align,
  wrap,
  gap,
  className,
  style: customStyle,
  children,
  ...props
}) {
  const style = {
    flexDirection: direction,
    justifyContent: justify,
    alignItems: align,
    flexWrap: wrap,
    gap,
    ...customStyle,
  };

  return (
    <div
      className={classNames(classes.flex, className)}
      style={style}
      {...props}
    >
      {children}
    </div>
  );
}

Flex.direction = ["row", "row-reverse", "column", "column-reverse"];
Flex.justify = [
  "flex-start",
  "center",
  "flex-end",
  "space-between",
  "space-around",
  "space-evenly",
];
Flex.align = ["flex-start", "center", "flex-end", "stretch", "baseline"];
Flex.wrap = ["nowrap", "wrap", "wrap-reverse"];

Flex.propTypes = {
  direction: PropTypes.oneOf(Flex.direction).isRequired,
  justify: PropTypes.oneOf(Flex.justify).isRequired,
  align: PropTypes.oneOf(Flex.align).isRequired,
  wrap: PropTypes.oneOf(Flex.wrap).isRequired,
  gap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

Flex.defaultProps = {
  direction: "row",
  justify: "center",
  align: "center",
  wrap: "nowrap",
};

export default Flex;
